import { createSelector } from 'reselect'
import {
  selectAgentViewTicketStatusesByTicketId,
  selectAgentReplyToTicketStatusesByTicketId,
  selectAgentTypeOnTicketStatusesByTicketId,
  selectAgentAddNoteStatusesByTicketId,
} from 'selectors/agents/base'
import { selectCurrentTicketId } from 'selectors/tickets'
import { emptyArr } from 'util/arrays'

export const selectAgentTypeOnTicketStatusesForCurrentTicket = createSelector(
  selectAgentTypeOnTicketStatusesByTicketId,
  selectCurrentTicketId,
  (agentsTypingByTicketId, currentTicketId) => {
    const result =
      (agentsTypingByTicketId &&
        currentTicketId &&
        agentsTypingByTicketId(currentTicketId)) ||
      []
    return result.length > 0 ? result : emptyArr
  }
)

export const selectAgentReplyToTicketStatusesForCurrentTicket = createSelector(
  selectAgentReplyToTicketStatusesByTicketId,
  selectAgentTypeOnTicketStatusesForCurrentTicket,
  selectCurrentTicketId,
  (agentsReplyingByTicketId, typingAgents, currentTicketId) => {
    const result = (
      (agentsReplyingByTicketId &&
        currentTicketId &&
        agentsReplyingByTicketId(currentTicketId)) ||
      []
    )
      .filter(agent => !!agent)
      .filter(agent => !typingAgents.map(a => a.id).includes(agent.id))
    return result.length > 0 ? result : emptyArr
  }
)

export const selectAgentAddNoteStatusesForCurrentTicket = createSelector(
  selectAgentAddNoteStatusesByTicketId,
  selectCurrentTicketId,
  (agentsAddingNoteByTicketId, currentTicketId) => {
    return (
      (agentsAddingNoteByTicketId &&
        currentTicketId &&
        agentsAddingNoteByTicketId(currentTicketId)) ||
      emptyArr
    )
  }
)

export const selectAgentViewTicketStatusesForCurrentTicket = createSelector(
  selectAgentViewTicketStatusesByTicketId,
  selectAgentTypeOnTicketStatusesForCurrentTicket,
  selectAgentReplyToTicketStatusesForCurrentTicket,
  selectAgentAddNoteStatusesForCurrentTicket,
  selectCurrentTicketId,
  (
    agentsViewingByTicketId,
    typingAgents,
    replyingAgents,
    noteLeavingAgents,
    currentTicketId
  ) => {
    const result = (
      (agentsViewingByTicketId &&
        currentTicketId &&
        agentsViewingByTicketId(currentTicketId)) ||
      []
    ).filter(
      agent =>
        agent &&
        !(
          replyingAgents.map(a => a.id).includes(agent.id) ||
          typingAgents.map(a => a.id).includes(agent.id) ||
          noteLeavingAgents.map(a => a.id).includes(agent.id)
        )
    )
    return result.length > 0 ? result : emptyArr
  }
)
